import Calendar from './Calendar';

export default Calendar;


//////////////////
// WEBPACK FOOTER
// ./~/rc-calendar/es/index.js
// module id = 682
// module chunks = 14